import React from 'react';
import ReactDOM from 'react-dom';
import './index.scss';
import 'antd/dist/antd.css';
import App from './App';
import { BrowserRouter } from 'react-router-dom';
import * as serviceWorker from './serviceWorker';
import './i18n';
import { Provider } from 'react-redux';
import store from './store';
import { AppCustomization } from './components/AppCustomization';

ReactDOM.render(
  <Provider store={store}>
    <BrowserRouter>
      <AppCustomization>
        <App />
      </AppCustomization>
    </BrowserRouter>
  </Provider>,
  document.getElementById('root')
);

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: http://bit.ly/CRA-PWA
serviceWorker.unregister();
